import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { _get, _post } from "../api/apiClient";
import { HttpStatusCode } from "axios";
import { CustomError } from "../api/CustomError";
import { CustomSuccess } from "../api/CustomSuccess";
import { setLoaderFalse, setLoaderTrue } from "./loaderSlice";
import { setForceLogout } from "../rtk-query/features/stripe/stripeSlice";

const initialState = {
  maintenanceData: {},
};

export const fetchHealthCheckApi = createAsyncThunk(
  "health-check-api",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(setLoaderTrue());
      const config = {
        successMessage: "Try again to login!",
        errorMessage: "Under Maintainance!",
      };

      const response = await _get(`/downtime`);

      if (response?.statusCode !== HttpStatusCode.Ok) {
        throw CustomError(response, config);
      }
      const { data, error, message, status, statusCode, responseType } =
        CustomSuccess(response, {
          ...config,
          disableToast: true,
        });

      if (data?.is_downtime) {
        thunkAPI.dispatch(setForceLogout(true));
      } else {
        thunkAPI.dispatch(setForceLogout(false));
      }

      thunkAPI.dispatch(setLoaderFalse());
      return {
        data,
        error,
        message,
        status,
        statusCode,
        responseType,
      };
    } catch (err) {
      if (disableLoader) thunkAPI.dispatch(setLoaderFalse());
      return thunkAPI.rejectWithValue(err);
    }
  },
);

export const maintenanceSlice = createSlice({
  name: "maintenanceSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchHealthCheckApi.pending, (_state, _action) => {
        _state.maintenanceData = {
          isLoading: true,
        };
      })
      .addCase(fetchHealthCheckApi.fulfilled, (_state, _action) => {
        _state.maintenanceData = {
          data: _action?.payload?.data,
          isLoading: false,
        };
      })
      .addCase(fetchHealthCheckApi.rejected, (_state, _action) => {
        _state.maintenanceData = {
          isLoading: false,
        };
      });
  },
});

export default maintenanceSlice.reducer;
